// Self-hosted per-icon SVGs (@material-symbols/svg-400, rounded/filled) —
// no network fetch at runtime, unlike the Google Fonts–hosted ligature font
// this replaces. Only the 12 glyphs the design actually uses are imported,
// each ~0.5KB, so switching away from the CDN font costs nothing in bundle
// size (the full variable font this package also ships would have cost
// several MB self-hosted — see specs/001-portal-landing-page/research.md).
import arrowForward from '@material-symbols/svg-400/rounded/arrow_forward-fill.svg?raw';
import bolt from '@material-symbols/svg-400/rounded/bolt-fill.svg?raw';
import chat from '@material-symbols/svg-400/rounded/chat-fill.svg?raw';
import darkMode from '@material-symbols/svg-400/rounded/dark_mode-fill.svg?raw';
import directionsCar from '@material-symbols/svg-400/rounded/directions_car-fill.svg?raw';
// `install_mobile` doesn't exist in this icon set (checked rounded/outlined,
// not a naming variant) — `install_desktop` substitutes: it's the exact
// glyph Chrome/Edge use for their own native "install this site as an app"
// affordance, so if anything it reads as more correct here, not less.
import installMobile from '@material-symbols/svg-400/rounded/install_desktop-fill.svg?raw';
import lightMode from '@material-symbols/svg-400/rounded/light_mode-fill.svg?raw';
import locationOn from '@material-symbols/svg-400/rounded/location_on-fill.svg?raw';
import mail from '@material-symbols/svg-400/rounded/mail-fill.svg?raw';
import moreHoriz from '@material-symbols/svg-400/rounded/more_horiz-fill.svg?raw';
import restaurant from '@material-symbols/svg-400/rounded/restaurant-fill.svg?raw';
import school from '@material-symbols/svg-400/rounded/school-fill.svg?raw';
import verified from '@material-symbols/svg-400/rounded/verified-fill.svg?raw';
import work from '@material-symbols/svg-400/rounded/work-fill.svg?raw';

export const icons = {
  arrow_forward: arrowForward,
  bolt,
  chat,
  dark_mode: darkMode,
  directions_car: directionsCar,
  install_mobile: installMobile,
  light_mode: lightMode,
  location_on: locationOn,
  mail,
  more_horiz: moreHoriz,
  restaurant,
  school,
  verified,
  work,
} as const;

export type IconName = keyof typeof icons;
